var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { required, minLength, maxLength, SimpleForm, TextInput, useTranslate, } from 'react-admin';
import { makeStyles, InputAdornment } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import { FORM_ERROR } from 'final-form';
import { useApiHub } from '../../ApiHubContext';
import { HtmlTooltip, PasswordInput } from '../../ui';
import { TermsInput } from './TermsInput';
import { AccountSetupToolbar } from './AccountSetupToolbar';
import { validatePassword } from '../validatePassword';
import isEmpty from 'lodash/isEmpty';
import { getErrorMessage } from '../../useLayer7Notify';
export const AccountSetupForm = props => {
    const { initialValues, onSubmit, toolbarProps, error = {} } = props, rest = __rest(props, ["initialValues", "onSubmit", "toolbarProps", "error"]);
    const classes = useStyles(rest);
    const translate = useTranslate();
    const { urlWithTenant, originHubName } = useApiHub();
    let flag = true;
    const validate = ({ password, confirm_password }) => {
        if (password !== confirm_password) {
            return {
                [FORM_ERROR]: 'apihub.account_setup.validation.error_password_match',
            };
        }
        if (!isEmpty(error) && flag) {
            const message = getErrorMessage(error);
            flag = false;
            return {
                userName: message,
            };
        }
    };
    return (React.createElement("div", { className: classes.root },
        React.createElement(SimpleForm, Object.assign({ className: classes.form, save: onSubmit, toolbar: React.createElement(AccountSetupToolbar, Object.assign({}, toolbarProps)), validate: validate, initialValues: initialValues }, rest),
            React.createElement(TextInput, { source: "firstName", type: "text", label: "apihub.account_setup.fields.firstname", variant: "outlined", fullWidth: true, validate: required() }),
            React.createElement(TextInput, { source: "lastName", type: "text", label: "apihub.account_setup.fields.lastname", variant: "outlined", fullWidth: true, validate: required() }),
            React.createElement(TextInput, { source: "email", type: "email", label: "apihub.account_setup.fields.email", variant: "outlined", fullWidth: true, validate: required(), disabled: true }),
            React.createElement(TextInput, { source: "userName", type: "text", label: "apihub.account_setup.fields.username", variant: "outlined", autoComplete: "new_username", fullWidth: true, InputProps: {
                    endAdornment: (React.createElement(InputAdornment, { position: "end" },
                        React.createElement(HtmlTooltip, { className: classes.tootip, title: translate('apihub.account_setup.validation.tooltip_username'), placement: "right", arrow: true },
                            React.createElement(InfoOutlined, null)))),
                }, validate: [required(), minLength(5), maxLength(60)] }),
            React.createElement(PasswordInput, { source: "password", label: "apihub.account_setup.fields.password", variant: "outlined", autoComplete: "new_password", fullWidth: true, validate: [required(), validatePassword], title: "apihub.account_setup.validation.tooltip_password" }),
            React.createElement(PasswordInput, { source: "confirm_password", label: "apihub.account_setup.fields.confirm_password", variant: "outlined", autoComplete: "confirm_new_password", fullWidth: true, validate: [required()], title: "apihub.account_setup.validation.tooltip_password_confirm" }),
            React.createElement(TermsInput, { source: "terms", type: "checkbox", validate: [mustBeTrue()] }))));
};
const mustBeTrue = () => value => !value
    ? 'apihub.account_setup.terms_of_use.terms_of_use_validation'
    : undefined;
const useStyles = makeStyles(theme => ({
    root: {},
    form: {
        '& >:first-child': {
            padding: 0,
        },
        '& .ra-input': {
            marginTop: theme.spacing(2),
        },
        paddingBottom: theme.spacing(4),
    },
}), {
    name: 'Layer7AccountSetupForm',
});
//# sourceMappingURL=AccountSetupForm.js.map